"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBox = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ModalBox = (0, _styledComponents["default"])(_slice.Box)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n  background-color: white;\n  z-index: 1001;\n  max-width: 600px;\n"], ["\n  position: relative;\n  background-color: white;\n  z-index: 1001;\n  max-width: 600px;\n"])));
exports.ModalBox = ModalBox;
ModalBox.defaultProps = {
  mx: 'auto',
  my: ['96px', '5%'],
  width: [1, 3 / 4]
};
var templateObject_1;